import React from 'react'
import PropTypes from 'prop-types'
import './index.css'
import _ from 'lodash'

class Radiobox extends React.Component {

  static defaultProps = {
    changeCheckedFun: () => {},
    options: []
  }

  render() {
    let { options, value, disabled } = this.props

    return (
      <div className="sdw-radiobox__wrap">
        {
          Array.isArray(options) &&
          !!options.length &&
          options.map((item, index) => (
            <span 
              key={index}
              className={ value === item.value ? 'current': ''}
              onClick={() => {
                if (_.isArray(disabled) && disabled.includes(item.value)) return
                this.props.changeCheckedFun(item.value)
              }}
            >
              <input
                value={item.text}
                type="radio"
                disabled={_.isArray(disabled) ? disabled.includes(item.value) : false}
                checked={value == item.value}
                onChange={_.noop}
                name={`onlyOne_${options[0].value}_${options[0].text}`}
              />
              <span className={ value === item.value ? 'radiobox-text current': 'radiobox-text'}>{item.text}</span>
            </span>
          ))  
        }
      </div>
    )
  }
}

Radiobox.propTypes = {
  options: PropTypes.array,
  changeCheckedFun: PropTypes.func,
  disabled: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
}

export default Radiobox